import {Component, EventEmitter, Output} from '@angular/core';
import {finalize} from 'rxjs/operators';
import {Prediction} from '../../../../../domain/prediction/prediction';
import {PredictionService} from '../../../../../domain/prediction/prediction.service';
import {Router} from '@angular/router';
import {HelperService} from '../../../../../domain/helper.service';
import {EnvironmentService} from '../../../../../core/services/environment.service';

@Component({
  selector: 'unknown-retry',
  templateUrl: './unknown-retry.component.html'
})
export class UnknownRetryComponent {
  isInProgress = false;

  @Output()
  retryChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private predictionService: PredictionService,
              private helperService: HelperService,
              private environmentService: EnvironmentService,
              private router: Router) {
  }

  onPhotoChange(blob: Blob): void {
    this.isInProgress = true;
    this.predictionService.upload(blob).pipe(
      finalize(() => this.isInProgress = false)
    ).subscribe(jtp => {
      if (jtp.request_new_picture) {
        this.retryChange.emit(true);
        return;
      }
      this.navigateWithState(jtp);
    });
  }

  navigateWithState(jtp: Prediction): void {
    const routeAdress = this.helperService.getRoutingPageFrom(jtp);
    this.router.navigateByUrl(routeAdress, {state: {jtp}});
  }

  onWebbookingNavigate(): void {
    document.location.href = this.environmentService.getWebbookingEndpoint;
  }

}
